const hslToHex = (h, s, l) => {
  h /= 360;
  s /= 100;
  l /= 100;

  let r, g, b;

  if (s === 0) {
    r = g = b = l;
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;

    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  const toHex = (x) => {
    const hex = Math.round(x * 255).toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

// Function to generate soft pastel shades
export const generateShades = (count) => {
  const shades = [];

  for (let i = 0; i < count; i++) {
    const hue = (i * (360 / count)) % 360; // Spread hues evenly
    const saturation = 20 + Math.random() * 20; // Keep saturation low (20% - 40%)
    const lightness = 80 + Math.random() * 10; // Keep lightness high (80% - 90%)

    shades.push(hslToHex(hue, saturation, lightness));
  }

  return shades;
};
